import { getPageName, getAnchorUrl } from 'helpers/pageHelpers'
import { useStoreSelector, useShallowSelector } from 'helpers/reactReduxHelpers'
import { isMemberPremiumSelector } from 'selectors/globalSelectors'
import { PREMIUM_PAGE_SET } from 'constants/pages'
import { makeUrlRelative } from 'helpers/utilsHelpers'
import { Anchor } from 'interfaces/navigation'
import { PopupRelationId } from 'interfaces/peergroups'
import { useMemo } from 'react'
import { createRelationSelector } from 'selectors/peergroupSelectors'

export const useShouldBlockPage = (location: string | Anchor): boolean | null => {
  const url = typeof location === 'string' && location.includes('/')
    ? makeUrlRelative(location)
    : getAnchorUrl(location as Anchor)

  const page = getPageName(url)

  const isMemberPremium = useStoreSelector(isMemberPremiumSelector)

  if (isMemberPremium === null) {
    return null
  }

  // we could not translate the page to url
  if (!page) {
    return false
  }

  return PREMIUM_PAGE_SET.has(page) && !isMemberPremium
}

export const useShouldBlockRelation = (relationId: PopupRelationId) => {
  const relationSelector = useMemo(createRelationSelector, [])
  const withRelationId = useMemo(() => ({ relationId }), [relationId])
  const isPremiunOnly = useShallowSelector((state) => {
    if (withRelationId.relationId === 'member') {
      return false
    }

    const relation = relationSelector(state, withRelationId as { relationId: Exclude<PopupRelationId, 'member'> })
    if (!relation) {
      return undefined
    }

    return relation.premium_only
  })

  const isMemberPremium = useShallowSelector(isMemberPremiumSelector)

  return !isMemberPremium && isPremiunOnly
}
